import { type FC } from 'react';

import { type TSpecialProjectBannerAnimateContext } from 'shared/types/bannerContext';
import { useAdfoxBannerContext } from 'shared/components/AdfoxBannerContext';

import { SpecialProjectAnimated } from './SpecialProjectAnimated';

type TSpecialProjectAnimatedContainerProps = {
  context: TSpecialProjectBannerAnimateContext;
};

export const SpecialProjectAnimatedContainer: FC<TSpecialProjectAnimatedContainerProps> = ({ context }) => {
  const { sizes } = useAdfoxBannerContext();

  return <SpecialProjectAnimated context={context} sizes={sizes} />;
};
